import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StyledButton from './MainButton.style';

const alignMap = {
  'center': 'center',
  'left': 'flex-start',
  'right': 'flex-end'
}

class MainButton extends Component {
  render = () => {
    const { icon } = this.props;

    let iconClass;
    if (icon && icon.color) {
      iconClass = 'tone colorIcon_'+icon.color;
    }

    // If we wanted to send image icons instead of simple colors
    // we could handle it here
    if (icon && icon.image) {
      iconClass = 'imageIcon_'+icon.image;
    }

    return (
      <StyledButton
        selected={this.props.selected}
        align={alignMap[this.props.align]}
        onClick={this.props.onClick}
      >
        {iconClass ? <div className={iconClass}/> : null}
        {this.props.children}
      </StyledButton>
    )

  }
}

MainButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.string,
  align: PropTypes.oneOf(['center', 'left', 'right']),
  icon: PropTypes.oneOfType([
    PropTypes.shape({
      color: PropTypes.string,
    }),
    PropTypes.shape({
      image: PropTypes.string
    })
  ])
};

export default MainButton;


// WEBPACK FOOTER //
// ./src/components/instore/MainButton.js